import { ApiHandler } from '../ApiHandler'

export abstract class CallApi {
  public static async history() {
    return await ApiHandler.get(
      'calls/history', {page: 1},
    )
  }
  public static async initiate(chatId: number, params: {callee_id: number, call_type: string}) {
    return await ApiHandler.post(
      `chats/${chatId}/call/initiate`,
      params,
    )
  }

  public static async accept(chatId: number, params: {call_id: number}) {
    return await ApiHandler.post(
      `chats/${chatId}/call/accept`,
      params,
    )
  }

  public static async reject(chatId: number, params: {call_id: number}) {
    return await ApiHandler.post(
      `chats/${chatId}/call/reject`,
      params,
    )
  }

  public static async end(chatId: number, params: {call_id: number}) {
    return await ApiHandler.post(
      `chats/${chatId}/call/end`,
      params,
    )
  }

  public static async cancel(chatId: number, params: {call_id: number}) {
    return await ApiHandler.post(
      `chats/${chatId}/call/cancel`,
      params,
    )
  }
}
